
import { motion } from 'framer-motion';
import { useInView } from '../../../hooks/useInView';

const sectors = [
  {
    icon: 'ri-flashlight-fill',
    title: 'Energetyka',
    description:
      'Konstrukcje dla elektrowni, stacji transformatorowych i infrastruktury energetycznej',
  },
  {
    icon: 'ri-fire-fill',
    title: 'Hutnictwo',
    description:
      'Zaawansowane rozwiązania dla przemysłu hutniczego i metalurgicznego',
  },
  {
    icon: 'ri-building-2-fill',
    title: 'Budownictwo',
    description:
      'Konstrukcje stalowe dla obiektów przemysłowych i użyteczności publicznej',
  },
  {
    icon: 'ri-settings-5-fill',
    title: 'Produkcja',
    description:
      'Oprzyrządowanie i konstrukcje dla zakładów produkcyjnych',
  },
];

export default function IndustrialSectors() {
  const [ref, isInView] = useInView({ threshold: 0.2 });

  return (
    <section
      ref={ref}
      className="relative py-16 sm:py-24 lg:py-32 bg-[#050505] overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/58852bf1e56ea2663f892798a69e794b.jpg"
          alt="Industrial Background"
          className="w-full h-full object-cover object-center opacity-20"
        />
        {/* Gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-[#050505] via-[#050505]/90 to-[#050505]"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 1 }}
          className="text-center mb-10 sm:mb-16 lg:mb-20"
        >
          <span
            className="text-[#00E5FF] text-xs sm:text-sm tracking-[0.3em] uppercase font-semibold"
            style={{ fontFamily: 'Orbitron, sans-serif' }}
          >
            Sektory Przemysłowe
          </span>
          <h2
            className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mt-3 sm:mt-4 leading-tight"
            style={{ fontFamily: 'Rajdhani, sans-serif' }}
          >
            Dla <span className="text-[#00E5FF]">Przemysłu</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 lg:gap-6">
          {sectors.map((sector, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.8, delay: index * 0.15 }}
              className="group relative"
            >
              <div className="relative bg-[#111111]/50 backdrop-blur-sm border border-[#00E5FF]/20 p-4 sm:p-6 lg:p-8 h-full hover:border-[#00E5FF] transition-all duration-500 hover:bg-[#111111]">
                <div className="w-12 h-12 sm:w-14 sm:h-14 lg:w-16 lg:h-16 flex items-center justify-center bg-[#00E5FF]/10 border border-[#00E5FF] mb-3 sm:mb-4 lg:mb-6 group-hover:bg-[#00E5FF] transition-all duration-300">
                  <i
                    className={`${sector.icon} text-xl sm:text-2xl lg:text-3xl text-[#00E5FF] group-hover:text-[#050505] transition-colors duration-300`}
                  ></i>
                </div>

                <h3
                  className="text-base sm:text-lg lg:text-xl font-bold text-white mb-2 sm:mb-3 leading-tight"
                  style={{ fontFamily: 'Rajdhani, sans-serif' }}
                >
                  {sector.title}
                </h3>

                <p
                  className="text-[#C0C7CF] text-[11px] sm:text-xs lg:text-sm leading-relaxed"
                  style={{ fontFamily: 'Inter, sans-serif' }}
                >
                  {sector.description}
                </p>

                <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-[#00E5FF] to-transparent transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500"></div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
